import WarehouseReducer from "./reducer";

export const openConnectDBModal = (payload) => (dispatch) => {
  dispatch(WarehouseReducer.actions.openConnectDBModal(payload));
};

export const setDBTypeValue = (payload) => (dispatch) => {
  dispatch(WarehouseReducer.actions.setDBTypeValue(payload));
};

export const setSelectDB = (payload) => (dispatch) => {
  dispatch(WarehouseReducer.actions.setSelectDB(payload));
};

export const setSelectDatabase = (payload) => (dispatch) => {
  dispatch(WarehouseReducer.actions.setSelectDatabase(payload));
};

export const setSelectTable = (payload) => (dispatch) => {
  dispatch(WarehouseReducer.actions.setSelectTable(payload));
};

export const setDatabaseList = (payload) => (dispatch) => {
  dispatch(WarehouseReducer.actions.setDatabaseList(payload));
};

export const clearDatabaseList = () => (dispatch) => {
  dispatch(WarehouseReducer.actions.clearDatabaseList());
};

export const clearSelectTable = () => (dispatch) => {
  dispatch(WarehouseReducer.actions.clearSelectTable());
};

export const clearSelectDB = () => (dispatch) => {
  dispatch(WarehouseReducer.actions.clearSelectDB());
};

export const setSelectBackupFile = (payload) => (dispatch) => {
  dispatch(WarehouseReducer.actions.setSelectBackupFile(payload));
};

export const clearSelectBackup = () => (dispatch) => {
  dispatch(WarehouseReducer.actions.clearSelectBackup());
};

export const closeConnectDBModal = (payload) => (dispatch) => {
  dispatch(WarehouseReducer.actions.closeConnectDBModal(payload));
};
